import { render } from "./Post.vue?vue&type=template&id=796d57fd&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=796d57fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796d57fd"]])

export default __exports__